import api from '@/services/utils/base';
import store from '@/store';

export default class AffiliateNetwork {
  get(id: string) {
    return api.get(`affiliate-networks/${id}`).then((res: any) => {
      return Promise.resolve(res.data.payload);
    })
  }

  getName(id: string) {
    return api.get(`affiliate-networks/name/${id}`);
  }

  getCount(payload: object) {
    return api.get('affiliate-networks/count', payload);
  }

  postCreate(payload: object) {
    return api.post('affiliate-networks', payload).then((res: any) => {
      return Promise.resolve(res.data.payload);
    })
    .catch((err: any) => {
      return Promise.reject(err);
    });
  }

  getList(params?:any) {
    return api.get('affiliate-networks', {params}).then((res: any) => {
      return Promise.resolve(res.data.payload);
    })
    .catch((err: any) => {
      return Promise.reject(err);
    });
  }

  putUpdate(id: string, payload: object) {
    return api.put(`affiliate-networks/${id}`, payload).then((res)=>{
      return Promise.resolve(res.data.payload);
    })
  }

  delete(id: string) {
    return api.delete(`affiliate-networks/${id}`);
  }

  postArchive(payload: object) {
    return api.post('affiliate-networks/archive', payload);
  }

  postRestore(payload: object) {
    return api.post('affiliate-networks/restore', payload);
  }

  postDuplicate(payload: object) {
    return api.post('affiliate-networks/duplicate', payload);
  }
  getTemplates(){
    return api.get('affiliate-networks-templates').then((res: any) => {
      return Promise.resolve(res.data.payload);
    });
  }

  populateStoreCache() {
    return api.get('affiliate-networks', {
      params:{
        status:'active',
        columns:[ 'id', 'name', 'workspaceId', 'templateId'],
        orderBy:'updated',
        orderDirection:'desc',
      }
    }).then((res: any) => {
      store.commit('populateAffiliateNetworksCache', res.data.payload);
      return Promise.resolve(res.data.payload);
    })
  }
}
